import { memo } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Skeleton,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import LogoOne7Ai from '../../../../assets/img/logo_one7_ai.png';
import useUploadCessaoHook from '../hooks/useUploadCessaoHook';
import UploadDocumentoAssinado from './UploadDocumentoAssinado/UploadDocumentoAssinado';
import ModalCancelarCessao from '../componentes/ModalCancelarCessao/ModalCancelarCessao';
import LoadingBoxUpload from '../componentes/LoadingBoxUpload/LoadingBoxUpload';
import ModalTitulosCedidos from '../componentes/ModalTitulosCedidos/ModalTitulosCedidos';
import './UploadCessao.scss';

const UploadCessao = ({ escopoAcesso, setEscopoAcesso, setCarregarTela }) => {
  const {
    onCloseModalTitulosCedidos,
    handleUploadedFilesChange,
    mostrarComponenteUpload,
    openModalTitulosCedidos,
    setMostrarEnvioTitulos,
    verificaTitulosCedidos,
    excluirArquivoEnviado,
    onCloseModalCancelar,
    setOpenModalCancelar,
    liberarBtnProsseguir,
    documentosPendencias,
    voltarParaSimulacao,
    loadingProsseguir,
    openModalCancelar,
    arquivosEnviados,
    tiposPendencias,
    onUploadFiles,
    columns,
    loading,
    rows
  } = useUploadCessaoHook({
    escopoAcesso,
    setEscopoAcesso,
    setCarregarTela
  });

  return (
    <Grid container className="container-sessao">
      <Grid item xs={12}>
        <Box className="sessao-topo">
          <Box className="subtitulo-sessao">
            <Button className="btn-voltar-sessao" onClick={() => voltarParaSimulacao()}>
              <KeyboardBackspaceIcon />
              voltar
            </Button>
            <Box className="titulo-sessao">Nova cessão</Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="box-limite-disponivel">
          <Box className="box-logo">
            <img src={LogoOne7Ai} className="logo-one-ai" alt="Logo One AI" />
          </Box>

          <Box className="box-upload-cessao">
            <Grid container className="container-box-upload">
              <Grid item xs={12} md={6} lg={4}>
                <Box className="box-simulacao">
                  <LoadingBoxUpload iniciar={true} onFim={() => setMostrarEnvioTitulos(true)} />
                </Box>
              </Grid>

              <Grid item xs={12} md={6} lg={8} className="grid-upload-titulos">
                {!loading && (
                  <>
                    {!mostrarComponenteUpload && (
                      <Box>
                        <Box className="box-label-superior">TÍTULOS ANALISADOS</Box>
                        <Box className="box-label-inferior">
                          A análise dos títulos foi concluída com sucesso.
                          <br />
                          Os títulos estão corretamente validados e prontos para prosseguir.
                        </Box>
                      </Box>
                    )}

                    {mostrarComponenteUpload && (
                      <Box>
                        <Box className="box-label-superior">TÍTULOS SELECIONADOS</Box>
                        <Box className="box-label-inferior">
                          Há títulos que necessitam de atenção pois possuem pendências.
                          {documentosPendencias.map(doc => (
                            <span key={doc}>
                              <br />
                              {tiposPendencias[doc]?.titulo || doc}
                            </span>
                          ))}
                        </Box>

                        <Paper elevation={1} className="colapse-titulos">
                          <Accordion className="accordion-titulos">
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography variant="body2" fontWeight={600}>
                                Ver títulos
                              </Typography>
                            </AccordionSummary>
                            <Box className="box-border-titulos" />

                            <AccordionDetails>
                              <DataGrid
                                rows={rows}
                                columns={columns}
                                className="data-grid-cessao"
                                pageSizeOptions={[10, 25, 50, 100]}
                                disableRowSelectionOnClick
                                initialState={{
                                  pagination: {
                                    paginationModel: {
                                      page: 0,
                                      pageSize: 10
                                    }
                                  }
                                }}
                                localeText={{
                                  ...ptBR.components.MuiDataGrid.defaultProps.localeText
                                }}
                              />
                            </AccordionDetails>
                          </Accordion>
                        </Paper>

                        <Box className="box-upload">
                          <Box className="box-label-inferior">
                            Envio de documentos pendentes (
                            {documentosPendencias
                              .map(doc => tiposPendencias[doc]?.documento || doc)
                              .join(', ')}
                            )
                          </Box>
                          <Grid container className="container-box-upload">
                            <Grid item xs={12} md={12} lg={12} xl={8}>
                              <UploadDocumentoAssinado
                                onFilesChange={onUploadFiles}
                                arquivosEnviados={arquivosEnviados}
                                onRemoveServerFile={excluirArquivoEnviado}
                                onUploadedFilesChange={handleUploadedFilesChange}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}
                  </>
                )}

                {loading && (
                  <Box className="box-simulacao">
                    <Box className="box-label-superior">
                      <Skeleton
                        className="skeleton-custom"
                        variant="rectangular"
                        animation="wave"
                        width="40%"
                        height={28}
                      />
                    </Box>
                    <Box className="box-label-inferior">
                      <Skeleton
                        className="skeleton-custom"
                        variant="rectangular"
                        animation="wave"
                        width="70%"
                        height={22}
                      />
                    </Box>

                    <Box className="box-upload">
                      <Skeleton
                        className="skeleton-custom"
                        variant="rectangular"
                        animation="wave"
                        width="30%"
                        height={22}
                      />

                      <Grid container className="box-label-inferior">
                        <Grid item xs={12} md={12} lg={12} xl={8}>
                          <Skeleton
                            className="skeleton-custom"
                            variant="rectangular"
                            animation="wave"
                            height={180}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>

          <Box className="box-btn-upload">
            <Button
              className="btn-cancelar"
              onClick={() => setOpenModalCancelar(true)}
              disabled={loadingProsseguir}
            >
              Cancelar
            </Button>
            <Button
              className="btn-processeguir-upload"
              onClick={() => verificaTitulosCedidos()}
              disabled={loadingProsseguir || !liberarBtnProsseguir}
            >
              <Box className="box-icone">
                {!loadingProsseguir && (
                  <>
                    Prosseguir com a documentação &nbsp;
                    <SyncAltIcon />
                  </>
                )}
                {loadingProsseguir && (
                  <>
                    Prosseguindo com a documentação &nbsp;
                    <CircularProgress size={20} color="inherit" />
                  </>
                )}
              </Box>
            </Button>
          </Box>
        </Box>
      </Grid>

      <ModalCancelarCessao open={openModalCancelar} onClose={onCloseModalCancelar} />

      <ModalTitulosCedidos
        open={openModalTitulosCedidos}
        onClose={onCloseModalTitulosCedidos}
        setCarregarTela={setCarregarTela}
      />
    </Grid>
  );
};

export default memo(UploadCessao);
